import React from 'react';
import '../../App.css';


export default function SignUp() {
         return <h1 class="sign-up">SIGN UP</h1>;
}